// @flow
import React, { useContext } from 'react';
import { If } from '@presentational/If';

import { EstimateContext } from '../contexts/EstimateContext';
import { getIfCustomerViewIsEnabled } from '../common-utils/utils';
import { WarningMessageContainer } from '../components/presentational/messages/WarningMessageContainer';

export const KafkaClustersAlertContainer = () => {
  const estimateData = useContext(EstimateContext);
  const isCustomerViewEnabled = getIfCustomerViewIsEnabled(estimateData?.inputs);
  const isClustersAlertSentByBE =
    estimateData?.alert_aggregations?.cluster_alert?.show_cluster_alert ?? false;
  const shouldShowAlert = isClustersAlertSentByBE && !isCustomerViewEnabled;

  return (
    <If test={shouldShowAlert}>
      <WarningMessageContainer message="ALERT: High Kafka cluster count, customer is eligible for additional Kafka-specific discounts. Do NOT quote list price on Kafka for this account." />
    </If>
  );
};
